import React from "react";
import Navbar from "../Navbar/Navbar";

import Card from "../Home/Card";
import Footer from "../Footer/Footer";
import Banner from "../Home/Banner";

export default function Rtr() {
  return (
    <div>
      <Navbar />
      <Banner />
      <Card />
      <Footer />
    </div>
  );
}
